(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-collection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-product-card')) {
    customElements.define(
      'collection-product-card',
      class CollectionProductCard extends HTMLElement {
        connectedCallback() {
          if (!this.initialized) {
            this.initialized = true;
            this.packButtons = Array.from(this.querySelectorAll('[data-pack-option]'));
            this.variantInput = this.querySelector('input[name="id"]');
            this.price = this.querySelector('[data-variant-price]');
            this.submitButton = this.querySelector('[type="submit"][name="add"]');
            this.submitLabel = this.querySelector('.collection-product-card__add-label');
            this.soldOutMessage = this.querySelector('.sold-out-message');
            this.favoriteButton = this.querySelector('[data-favorite-button]');
            this.productId = String(this.dataset.productId);

            this.packButtons.forEach((button) => {
              button.addEventListener('click', () => this.selectVariant(button));
            });

            this.favoriteButton?.addEventListener('click', () => this.toggleFavorite());
            this.onFavoritesChanged = (event) => this.updateFavoriteState(event.detail.favorites);
          }

          window.removeEventListener('bonez:favorites-changed', this.onFavoritesChanged);
          window.addEventListener('bonez:favorites-changed', this.onFavoritesChanged);
          this.updateFavoriteState(this.getFavorites());
        }

        disconnectedCallback() {
          window.removeEventListener('bonez:favorites-changed', this.onFavoritesChanged);
        }

        getFavorites() {
          const cookie = document.cookie
            .split('; ')
            .find((entry) => entry.startsWith('bonez_favorite_products='));

          if (!cookie) return [];

          try {
            const value = cookie.slice(cookie.indexOf('=') + 1);
            const favorites = JSON.parse(decodeURIComponent(value));
            return Array.isArray(favorites) ? favorites.map(String) : [];
          } catch (_error) {
            return [];
          }
        }

        saveFavorites(favorites) {
          const limitedFavorites = favorites.slice(-100);
          const secure = window.location.protocol === 'https:' ? '; Secure' : '';
          document.cookie = `bonez_favorite_products=${encodeURIComponent(
            JSON.stringify(limitedFavorites)
          )}; path=/; max-age=31536000; SameSite=Lax${secure}`;
          window.dispatchEvent(
            new CustomEvent('bonez:favorites-changed', { detail: { favorites: limitedFavorites } })
          );
        }

        toggleFavorite() {
          const favorites = this.getFavorites();
          const favoriteIndex = favorites.indexOf(this.productId);

          if (favoriteIndex >= 0) {
            favorites.splice(favoriteIndex, 1);
          } else {
            favorites.push(this.productId);
          }

          this.saveFavorites(favorites);
        }

        updateFavoriteState(favorites) {
          if (!this.favoriteButton) return;

          const isFavorite = favorites.includes(this.productId);
          const actionText = isFavorite
            ? this.dataset.removeFromFavoritesText
            : this.dataset.addToFavoritesText;

          this.favoriteButton.classList.toggle('is-favorite', isFavorite);
          this.favoriteButton.setAttribute('aria-pressed', isFavorite ? 'true' : 'false');
          this.favoriteButton.setAttribute('aria-label', `${actionText}: ${this.querySelector('.collection-product-card__title a')?.textContent.trim() || ''}`);
        }

        selectVariant(button) {
          const available = button.dataset.variantAvailable === 'true';

          this.packButtons.forEach((packButton) => {
            const selected = packButton === button;
            packButton.classList.toggle('is-selected', selected);
            packButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          if (this.variantInput) this.variantInput.value = button.dataset.variantId;
          if (this.price) this.price.textContent = button.dataset.variantPrice;

          if (this.submitButton) {
            this.submitButton.disabled = !available;
            this.submitButton.toggleAttribute('aria-disabled', !available);
          }

          if (this.submitLabel) {
            this.submitLabel.textContent = available ? 'Add To Cart' : this.dataset.soldOutText;
            this.submitLabel.classList.remove('hidden');
          }

          if (this.soldOutMessage) this.soldOutMessage.classList.add('hidden');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cookie-consent')) {
    class BonezCookieConsent extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.banner = this.querySelector('[data-cookie-banner]');
        this.modal = this.querySelector('[data-cookie-modal]');
        this.statusElements = this.querySelectorAll('[data-cookie-status]');
        this.liveStatus = this.querySelector('[data-cookie-live-status]');
        this.inputs = Object.fromEntries(
          Array.from(this.querySelectorAll('[data-consent-input]')).map((input) => [input.dataset.consentInput, input])
        );
        this.pending = false;
        this.lastFocusedElement = null;
        this.isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

        this.addEventListener('click', (event) => this.handleComponentClick(event), { signal });
        this.banner.addEventListener('cancel', (event) => event.preventDefault(), { signal });
        this.modal.addEventListener('close', () => this.restoreFocus(), { signal });
        document.addEventListener('click', (event) => this.handleDocumentClick(event), { signal });
        document.addEventListener('visitorConsentCollected', () => this.handleConsentCollected(), { signal });

        this.loadPrivacyApi();
      }

      disconnectedCallback() {
        this.abortController.abort();
      }

      loadPrivacyApi() {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          this.handleApiError();
          return;
        }

        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          (error) => {
            if (error || !window.Shopify.customerPrivacy) {
              this.handleApiError();
              return;
            }

            this.privacy = window.Shopify.customerPrivacy;
            this.syncControls();

            if (this.isDesignMode) {
              this.applyEditorPreview();
              return;
            }

            try {
              if (this.privacy.shouldShowBanner()) this.showBanner();
            } catch (error) {
              this.handleApiError();
            }
          }
        );
      }

      applyEditorPreview() {
        if (this.dataset.editorPreview === 'banner') this.showBanner();
        if (this.dataset.editorPreview === 'modal') this.openPreferences();
      }

      handleComponentClick(event) {
        const openButton = event.target.closest('[data-open-cookie-preferences]');
        const closeButton = event.target.closest('[data-close-cookie-preferences]');
        const actionButton = event.target.closest('[data-consent-action]');

        if (openButton) this.openPreferences(openButton);
        if (closeButton) this.modal.close();
        if (!actionButton) return;

        const action = actionButton.dataset.consentAction;
        if (action === 'necessary') {
          this.saveConsent({ preferences: false, analytics: false, marketing: false });
        }
        if (action === 'all') {
          this.saveConsent({ preferences: true, analytics: true, marketing: true });
        }
        if (action === 'save') {
          this.saveConsent({
            preferences: this.inputs.preferences.checked,
            analytics: this.inputs.analytics.checked,
            marketing: this.inputs.marketing.checked,
          });
        }
      }

      handleDocumentClick(event) {
        const trigger = event.target.closest('[data-cookie-preferences-trigger]');
        if (!trigger) return;
        event.preventDefault();
        this.openPreferences(trigger);
      }

      openPreferences(trigger) {
        if (trigger) this.lastFocusedElement = trigger;
        this.syncControls();
        if (!this.modal.open) this.modal.showModal();
      }

      restoreFocus() {
        if (!this.lastFocusedElement || !document.contains(this.lastFocusedElement)) return;
        this.lastFocusedElement.focus();
        this.lastFocusedElement = null;
      }

      showBanner() {
        if (this.banner.open) return;
        if (this.dataset.position === 'center') {
          this.banner.setAttribute('aria-modal', 'true');
          this.banner.showModal();
          return;
        }
        this.banner.removeAttribute('aria-modal');
        this.banner.show();
      }

      hideBanner() {
        if (this.banner.open) this.banner.close();
      }

      syncControls() {
        if (!this.privacy) return;

        let current = {};
        try {
          current = this.privacy.currentVisitorConsent();
        } catch (error) {
          current = {};
        }

        this.inputs.preferences.checked = this.resolveConsent(
          current.preferences,
          'preferencesProcessingAllowed'
        );
        this.inputs.analytics.checked = this.resolveConsent(
          current.analytics,
          'analyticsProcessingAllowed'
        );
        this.inputs.marketing.checked = this.resolveConsent(current.marketing, 'marketingAllowed');
      }

      resolveConsent(value, allowedMethod) {
        if (value === 'yes') return true;
        if (value === 'no') return false;
        if (typeof this.privacy[allowedMethod] !== 'function') return false;
        return Boolean(this.privacy[allowedMethod]());
      }

      saveConsent(consent) {
        if (this.isDesignMode) {
          this.setStatus('', false);
          return;
        }
        if (!this.privacy || this.pending) {
          this.setStatus(this.dataset.statusError, true);
          return;
        }

        this.setPending(true);
        this.setStatus(this.dataset.statusSaving, false);

        try {
          this.privacy.setTrackingConsent(consent, (result) => {
            if (result && result.error) {
              this.handleSaveError();
              return;
            }

            this.inputs.preferences.checked = consent.preferences;
            this.inputs.analytics.checked = consent.analytics;
            this.inputs.marketing.checked = consent.marketing;
            this.setPending(false);
            this.setStatus('', false);
            this.closeAfterSave();
          });
        } catch (error) {
          this.handleSaveError();
        }
      }

      handleConsentCollected() {
        this.syncControls();
        if (!this.pending) this.hideBanner();
      }

      handleSaveError() {
        this.setPending(false);
        this.setStatus(this.dataset.statusError, true);
        if (!this.modal.open) this.showBanner();
      }

      closeAfterSave() {
        const shouldFocusMain = this.lastFocusedElement && this.banner.contains(this.lastFocusedElement);

        if (this.modal.open) {
          if (shouldFocusMain) this.lastFocusedElement = null;
          this.modal.close();
        }
        this.hideBanner();
        if (shouldFocusMain) document.querySelector('#MainContent')?.focus();
      }

      handleApiError() {
        this.setPending(false);
        this.setStatus(this.dataset.statusError, true);
        if (this.isDesignMode) {
          this.applyEditorPreview();
          return;
        }
        this.showBanner();
      }

      setPending(isPending) {
        this.pending = isPending;
        this.toggleAttribute('aria-busy', isPending);
        this.querySelectorAll('[data-consent-action]').forEach((button) => {
          button.disabled = isPending;
        });
      }

      setStatus(message, isError) {
        this.statusElements.forEach((element) => {
          element.textContent = message;
          element.hidden = !message;
          element.dataset.error = String(isError);
        });
        this.liveStatus.textContent = message;
      }
    }

    customElements.define('cookie-consent', BonezCookieConsent);
  }
  } catch(e) { console.error(e); }
})();

})();
